import { OpenInBrowserRounded } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { ShareButton } from "src/components";

interface Props {
  link: string;
}

const ItemDrawerTitle = ({ link }: Props) => {
  const navigate = useNavigate();

  return (
    <Stack direction="row" spacing={0.5}>
      <Button variant="tertiary" startIcon={<OpenInBrowserRounded />} onClick={() => navigate(link)}>
        Open Page
      </Button>
      <ShareButton variant="tertiary" href={`${window.origin}${link}`} />
    </Stack>
  );
};

export { ItemDrawerTitle };
